// @ts-nocheck 327e3bf9
import * as actions from './tpaActions';
import * as tpaSelectors from './tpaSelectors';

export { actions, tpaSelectors as selectors };
